import { SubscriptionActionTypes } from './subscription.types'

//Subscription list
export const subscriptionListRequest = (data) => ({
    type: SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST,
    payload: data
})

export const subscriptionListRequestSuccess = data => ({
    type: SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST_SUCCESS,
    payload: data
})

export const subscriptionListRequestError = data => ({
    type: SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST_ERROR,
    payload: data
})

//Add Subscription
export const addSubscriptionRequest = (data) => ({
    type: SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST,
    payload: data
})

export const addSubscriptionRequestSuccess = (data) => ({
    type: SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_SUCCESS,
    payload: data
})

export const addSubscriptionRequestError = (data) => ({
    type: SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_ERROR,
    payload: data
})

export const addSubscriptionRequestStatus = (data) => ({
    type: SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_STATUS,
    payload: data
})

//Update Subscription
export const updateSubscriptionRequest = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST,
    payload: data
})

export const updateSubscriptionRequestSuccess = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_SUCCESS,
    payload: data
})

export const updateSubscriptionRequestError = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_ERROR,
    payload: data
})

export const updateSubscriptionRequestStatus = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_STATUS,
    payload: data
})

//Update Subscription Status
export const updateSubscriptionStatusRequest = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST,
    payload: data
})

export const updateSubscriptionStatusRequestSuccess = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const updateSubscriptionStatusRequestError = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_ERROR,
    payload: data
})

export const updateSubscriptionStatusRequestStatus = (data) => ({
    type: SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_STATUS,
    payload: data
})

//Update Transaction Status
export const updateTransactionStatusRequest = (data) => ({
    type: SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST,
    payload: data
})

export const updateTransactionStatusRequestSuccess = (data) => ({
    type: SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const updateTransactionStatusRequestError = (data) => ({
    type: SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_ERROR,
    payload: data
})

export const updateTransactionStatusRequestStatus = (data) => ({
    type: SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_STATUS,
    payload: data
})

//New transaction
export const newTransactionRequest = (data) => ({
    type: SubscriptionActionTypes.NEW_TRANSACTION_REQUEST,
    payload: data
})

export const newTransactionRequestSuccess = (data) => ({
    type: SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_SUCCESS,
    payload: data
})

export const newTransactionRequestError = (data) => ({
    type: SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_ERROR,
    payload: data
})

export const newTransactionRequestStatus = (data) => ({
    type: SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_STATUS,
    payload: data
})